import React from "react";
import { AppBottomSheet } from "../Generic/AppBottomSheet";
import RadioGroup from "../Generic/RadioGroup";
import Flex from "../Generic/Flex";
import { AppOverlay } from "../Generic/AppOverlay";
import "./MystaffingPreferences.scss";
import { CaregiverStaffingPreferenceTypes } from "../../messages";
import { ChevronRightIcon } from "../../utils/icones";
import { translate } from "../../translate";
import { STRINGS } from "../../strings";

interface StaffingPreferenceSelectProps {
  label: string;
  type: CaregiverStaffingPreferenceTypes;
  options: {
    title: string;
    value: string | number;
  }[];
  value: string | number | null;
  onChange: (preference: CaregiverStaffingPreferenceTypes, value: string | number | null) => void;
}

const StaffingPreferenceSelect = (props: StaffingPreferenceSelectProps) => {
  const [isOptionsModalOpen, setIsOptionsModalOpen] = React.useState(false);
  const selectedOption = props.options.find((option) => option.value === props.value) ?? null;

  const handleChange = (value: string) => {
    const option = props.options.find((option) => option.value.toString() === value);

    setIsOptionsModalOpen(false);
    props.onChange(props.type, option?.value ?? null);
  };

  return (
    <>
      <Flex
        onClick={() => setIsOptionsModalOpen(true)}
        direction="row"
        gap={5}
        justifyContent="space-between"
        alignItems="center"
      >
        <Flex direction="column" gap={4}>
          <div> {props.label} </div>
          <div className="MyStaffingPreferences__Answer">
            {selectedOption?.title ?? translate(STRINGS.NOT_SELECTED)}
          </div>
        </Flex>
        <div className="MyStaffingPreferences__ChevronIcon">
          <ChevronRightIcon />
        </div>
      </Flex>
      <OptionsPopupModal
        selectedValue={selectedOption?.title ?? null}
        isOpen={isOptionsModalOpen}
        options={props.options}
        onRequestClose={() => setIsOptionsModalOpen(false)}
        onValueChange={handleChange}
      />
    </>
  );
};

export default StaffingPreferenceSelect;

const OptionsPopupModal = (props: {
  isOpen: boolean;
  selectedValue: string | number | null;
  options: {
    title: string;
    value: string | number;
  }[];
  onRequestClose: () => void;
  onValueChange: (value: string) => void;
}) => {
  return (
    <AppOverlay>
      <AppBottomSheet
        isOpen={props.isOpen}
        onRequestClose={props.onRequestClose}
        className="MyStaffingPreferences_SelectOptionsModal"
      >
        <RadioGroup.Root
          className="MyStaffingPreferences_SelectOption"
          onValueChange={props.onValueChange}
        >
          {props.options.map((option, index) => (
            <Flex key={`option-${index}`} gap={10}>
              <RadioGroup.Item
                value={option.value.toString()}
                checked={props.selectedValue === option.value}
              />
              <div>{option.title}</div>
            </Flex>
          ))}
        </RadioGroup.Root>
      </AppBottomSheet>
    </AppOverlay>
  );
};
